module.exports = __webpack_public_path__ + "static/img/activityBanner.3b0c0ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/activityBanner.png
// module id = TrYX
// module chunks = 39